import { OnboardingFormActions } from '../../../enums'
import { AddATMAction } from '../../../types/actions'

export const addATM = (companyIndex: number): AddATMAction => ({
  type: OnboardingFormActions.ADD_ATM,
  payload: { companyIndex }
})
